let focusTarget: HTMLElement | null = null

export const registerBoxSummaryTreatmentFocusTarget = (element: HTMLElement | null) => {
  focusTarget = element
}

export const restoreBoxSummaryTreatmentFocus = () => {
  if (focusTarget?.isConnected) {
    focusTarget.focus()
  }

  focusTarget = null
}
